import { createMask } from 'imask'
import get from 'lodash/get'
import set from 'lodash/set'
import isEmpty from 'lodash/isEmpty'
import MASKS from '@/lib/constants/mask'

export const maskInput = ({ field, maskOptions, setMaskValue }) => {
  const mask = createMask(maskOptions)

  return {
    get () {
      const val = get(this, field)
      return isEmpty(val) ? '' : mask.resolve(val)
    },
    set (value) {
      if (isEmpty(value)) {
        set(this, field, '')
        return
      }

      mask.resolve(value || '')
      const valueToSet = setMaskValue ? mask.value : mask.unmaskedValue
      set(this, field, valueToSet)
    },
  }
}

export const maskNumberInput = (field) => maskInput({ field, maskOptions: MASKS.NUMBER })

export const maskCurrencyInput = (field) => maskInput({ field, maskOptions: MASKS.MONEY })

export const maskZipCodeInput = (field) => maskInput({ field, maskOptions: MASKS.ZIP_CODE })

export const maskCpfInput = (field) => maskInput({ field, maskOptions: MASKS.CPF })

export const maskPhoneInput = (field, setMaskValue) => maskInput(
  { field, maskOptions: MASKS.PHONE, setMaskValue },
)

export const currencyTransformer = (value) => {
  const currencyFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

  return currencyFormatter.format(value)
}

